// extracted by mini-css-extract-plugin
export default {"price-input":"_6Q6LO","priceInput":"_6Q6LO","premium-selected":"_2PwFQ","premiumSelected":"_2PwFQ","full-width":"_7gycl","fullWidth":"_7gycl"};